import { render, staticRenderFns } from "./WhatsappShare.vue?vue&type=template&id=ca916dfc"
import script from "./WhatsappShare.vue?vue&type=script&lang=js"
export * from "./WhatsappShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports